<template>
  <div class="edit_main">
    <Form
      class="fx_1"
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
      inline
    >
      <FormItem label="用户名" prop="userName">
        <Input class="w-250" v-model="editModel.userName"></Input>
      </FormItem>
      <FormItem label="用户编号" prop="userCode">
        <Input class="w-250" v-model="editModel.userCode"></Input>
      </FormItem>

      <FormItem label="用户类型" prop="userType">
        <Select class="w-250" v-model="editModel.userType">
          <Option
            v-for="(item, index) in userTypeSelect"
            :value="item.dictionaryID"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="英文名">
        <Input class="w-250" v-model="editModel.userNameEN"></Input>
      </FormItem>
      <FormItem label="性别">
        <Select class="w-250" v-model="editModel.userSex" clearable>
          <Option value="0">男</Option>
          <Option value="1">女</Option>
        </Select>
      </FormItem>
      <FormItem label="身份证号">
        <Input class="w-250" v-model="editModel.idCardNO"></Input>
      </FormItem>
      <FormItem label="出生日期">
        <DatePicker
          v-model="editModel.userBirth"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>
      <FormItem label="入职日期">
        <DatePicker
          v-model="editModel.entryDate"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>
      <FormItem label="离职日期">
        <DatePicker
          v-model="editModel.quitDate"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>

      <FormItem label="手机号">
        <Input class="w-250" v-model="editModel.userMobile"></Input>
      </FormItem>
      <FormItem label="座机号">
        <Input class="w-250" v-model="editModel.userTell"></Input>
      </FormItem>
      <FormItem label="邮箱">
        <Input class="w-250" v-model="editModel.userEmail"></Input>
      </FormItem>
      <FormItem label="住址">
        <Input class="w-250" v-model="editModel.userAddress"></Input>
      </FormItem>

      <FormItem label="选择科室" required>
        <Button type="primary" @click="treeModel = true">选择科室</Button>
        <span class="ml-5">{{ editModel.departmentname }}</span>
      </FormItem>

      <FormItem label="备注" class="show">
        <Input
          class="w-250"
          v-model="editModel.userRemark"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 8 }"
        ></Input>
      </FormItem>
      <FormItem label="签名">
        <Upload
          ref="uploadFile"
          :action="uploadUrl"
          :headers="headers"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <!-- :show-upload-list="false" -->
          <Button icon="ios-cloud-upload-outline">选择图片</Button>
        </Upload>
        <img
          v-bind:src="signimageUrl"
          style="max-width: 500px; max-height: 500px"
        />
      </FormItem>
    </Form>

    <div class="text-center">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>

    <Modal
      v-model="treeModel"
      width="800px"
      title="选择科室"
      :footer-hide="true"
    >
      <departmentSelect @selectDepartment="selectDepartment"></departmentSelect>
    </Modal>
  </div>
</template>
<script>
import departmentSelect from "../department/departmentSelect.vue";
import token from "../../../utils/token.js";

export default {
  components: { departmentSelect },
  data: function () {
    return {
      userTypeSelect: [],
      treeModel: false,
      organParentName: "",

      headers: "",
      uploadUrl: "",
      signimageUrl: "",
      editModel: {
        userID: "",
        userName: "",
        userCode: "",
        userType: "",
        userNameEN: "",
        userSex: "",
        userBirth: "",
        entryDate: "",
        quitDate: "",
        idCardNO: "",
        userMobile: "",
        userTell: "",
        userAddress: "",
        userEmail: "",
        userRemark: "",

        organID: "",
        organName: "",
        departmentID: "",
        departmentname: "",
        signImage: "",
      },
      ruleValidate: {
        userName: [
          {
            required: true,
            message: "用户名不能为空",
          },
        ],
        userCode: [
          {
            required: true,
            message: "用户编号不能为空",
          },
        ],
        userType: [
          {
            required: true,
            message: "用户类型不能为空",
          },
        ]
      },
    };
  },
  mounted () {
    console.log(this.$route.query.id)
    this.$common.getDictionary("用户类型").then((data) => {
      this.userTypeSelect = data;
    });
    this.initData(this.$route.query.id);
    let baseUrl = localStorage.getItem("baseURL");
    this.uploadUrl = baseUrl + "/user/UploadImage";
    this.headers = { Authorization: "Bearer " + token.getToken() };
  },

  methods: {
    initData(id) {
      this.$api.get(`user/getById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          this.editModel = rsp.data;
          this.signimageUrl =
            localStorage.getItem("baseURL") + this.editModel.signImage;
        }
      });
    },
    returnBack: function () {
      this.$router.push("user");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (!this.editModel.departmentID) {
            this.$Message.warning("请选择所属科室");
            return;
          }
          this.editModel.userBirth =
            this.editModel.userBirth == "" ? null : this.editModel.userBirth;
          this.editModel.entryDate =
            this.editModel.entryDate == "" ? null : this.editModel.entryDate;
          this.editModel.quitDate =
            this.editModel.quitDate == "" ? null : this.editModel.quitDate;
          this.$api.post("user/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
            }
          });
        }
      });
    },

    selectDepartment: function (data) {
      this.treeModel = false;
      this.editModel.departmentID = data.departmentID;
      this.editModel.departmentName = data.departmentName;
      this.editModel.organID = data.organID;
      this.editModel.organName = data.organName;
    },
    //导入
    uploadSuccess: function (response, file, fileList) {
      if (response.statusCode == 200) {
        this.$Message.success("上传成功");
        this.editModel.signImage = response.data;

        this.fileName = file.name;
        this.signimageUrl = localStorage.getItem("baseURL") + response.data;
      } else {
        this.$Message.success(response.msg);
      }
    },

    cancel: function () {},
    uploadError: function (error, file, fileList) {
      this.$Message.success("上传失败");
    },
  },
};
</script>
<style scoped>
</style>